module.exports = __webpack_public_path__ + "static/media/terminal.b9861e4a.svg";